import { defineComponent, openBlock, createBlock } from 'vue';

var script = /*#__PURE__*/defineComponent({
  name: "VueUtterances",

  // vue component name
  data() {
    return {};
  },

  props: {
    repo: {
      type: String,
      default: "[ENTER REPO HERE]",
      required: true
    },
    issueTerm: {
      type: String,
      default: "pathname"
    },
    theme: {
      type: String,
      default: "github-light"
    }
  },

  mounted() {
    let utterances = document.createElement("script");
    utterances.async = true;
    utterances.setAttribute("src", "https://utteranc.es/client.js");
    utterances.setAttribute("repo", this.repo);
    utterances.setAttribute("issue-term", this.issueTerm);
    utterances.setAttribute("theme", this.theme);
    utterances.setAttribute("crossorigin", "anonymous");
    this.$refs.vueUtterances.appendChild(utterances);
  },

  watch: {
    theme: function (newTheme, oldTheme) {
      console.log(newTheme);
      console.log(oldTheme);
      this.$refs.vueUtterances.querySelector("iframe").contentWindow.postMessage({
        type: "set-theme",
        theme: newTheme // theme you want

      }, "https://utteranc.es");
    }
  }
});

const _hoisted_1 = {
  class: "vue-utterances",
  ref: "vueUtterances"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1, null, 512);
}

script.render = render;

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('VueUtterances', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export default entry_esm;
